import { cloneElement, isValidElement } from "react";
import "./css/output.css";
export default function ArrayValue({
  label,
  value,
  children,
  className,
  ...props
}) {
  const computedClassName = ["output", "array-value", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && (
        <div>
          <strong>{label}</strong>
        </div>
      )}
      {children instanceof Function &&
        children({
          value,
        })}
      {isValidElement(children) &&
        cloneElement(children, {
          value,
        })}
    </div>
  );
}

ArrayValue.defaultProps = {
  className: "",
};
